//
//
//
//
//
//
//

export default {
	name: "tag",
	props: {
		text: { type: String },
	},
};
